/** نصوص الموقع — عربي فقط. عدّل أي نص من هنا مباشرة. */
export const content = {
  // ===== الهيدر =====
  navProblem: "المشكلة",
  navFeatures: "المميزات",
  navSafety: "الأمان",
  navReviews: "الآراء",
  navHow: "كيف بيشتغل",
  navFaq: "الأسئلة",
  navWhatsapp: "تواصل عن طريق واتساب",
  headerCta: "اطلب الآن",

  // ===== الهيرو =====
  discount: "خصم 32%",
  // عنوان قصير يقع في سطر واحد على الجوال، ووصف من سطر واحد تحته
  heroTitle: "مكواة البخار  ",
  heroTitleHighlight: "العامودي",
  heroSubtitle: "ملابسك جاهزة خلال دقيقة",
  // شريط مواصفات مضغوط بدل النقاط الطويلة — نفس المعلومة بربع المساحة،
  // والتفصيل الكامل موجود في قسم المميزات تحته مباشرة
  heroSpecs: [
    { icon: "fa-bolt", value: "1800", label: "واط" },
    { icon: "fa-gauge-high", value: "45", label: "ثانية" },
    { icon: "fa-droplet", value: "1.6", label: "لتر" },
    { icon: "fa-shield", value: "آمن", label: "كل الأقمشة" },
  ],
  heroPriceLabel: "سعر العرض",
  heroSaveLabel: "وفّر",
  btnBuyNow: "اطلب الآن — الدفع عند الاستلام",
  btnLearnMore: "شوف كيف بيشتغل",
  customersLine: "عميل استلم طلبه",
  trustWarranty: "وكالة سنة كاملة",
  trustDelivery: "توصيل من يومين إلى 4 أيام",
  trustCod: "دفع عند الاستلام",

  // ===== قسم الألم =====
  painEyebrow: "شو بيحل المنتج",
  painTitle: "هل شعرت بهذا",
  painTitleHighlight: "الشعور؟",
  painSubtitle: "إذا واجهتك مشكلة من هالمشاكل فإنتي وجدتي الحل ",
  painItems: [
    {
      icon: "fa-clock",
      title: "ملابسك حساسة وقماشتها غالية",
      desc: "هيك نوع بدو المكواية البخارية",
    },
    {
      icon: "fa-table",
      title: "طاولة الكوي معركة كل مرة",
      desc: "تطلّعها، تركّبها، تكوي قطعة وحدة، وترجّعها. مجهود أكبر من الكوي نفسه.",
    },
    {
      icon: "fa-fire",
      title: "أثر الحرق ما بينمحي",
      desc: "قميص غالي راح بثانية سهو وحدة. المكواية العادية مبتسامحش.",
    },
    {
      icon: "fa-hourglass-half",
      title: "عندك اطفال وخايفة عليهم",
      desc: "المكواية العادية بترحمش",
    },
    {
      icon: "fa-shirt",
      title: "في قطع ما بتنكوي بالمكواية العادية",
      desc: "الستائر والمفروشات وغطاء الكنب راح تكويها بكل سهولة",
    },
    {
      icon: "fa-wind",
      title: "أثر الخزانة العالقة",
      desc: "الملابس بدها إنعاش مش بس فرد تجاعيد، والمكواية العادية ما بتعمل هيك.",
    },
  ],

  // ===== طريقة الاستخدام =====
  howEyebrow: "أسهل مما تتخيل",
  howTitle: "3 خطوات…",
  howTitleHighlight: "وخلص",
  howSteps: [
    {
      num: "1",
      title: "عبّي الخزان",
      desc: "ماء عادي من الصنبور، 1.6 لتر تكفيك أسبوع.",
    },
    {
      num: "2",
      title: "شغّله وانتظر 30 ثانية",
      desc: "ضوء أخضر بيخبرك إنه جاهز للبخار.",
    },
    {
      num: "3",
      title: "مرّر البخار من فوق لتحت",
      desc: "التجاعيد بتختفي قدام عينك بدون ما تلمس القماش.",
    },
  ],

  // ===== المميزات =====
  designedForYou: "مصمم خصيصاً من أجلك",
  featuresTitle: "لماذا تختار",
  featuresTitleHighlight: "مكوى MATRXS؟",
  featuresSubtitle: "كل ميزة هنا موجودة لتحلّ مشكلة عشتها فعلاً.",
  feat1Title: "تصميم مميز وآمن",
  feat1Desc:
    "يضمن لك استخداماً آمناً في المنزل بفضل تصميمه العصري وأنظمة الأمان المتطورة.",
  feat2Title: "بقوة 1800 واط",
  feat2Desc:
    "قوة تسخين عالية لإنتاج بخار كثيف يزيل أصعب التجاعيد بسرعة وكفاءة.",
  feat3Title: "خزان مياه 1.6 لتر",
  feat3Desc:
    "سعة كبيرة تسمح بكي كمية كبيرة من الملابس دون الحاجة لإعادة التعبئة المستمرة.",
  feat4Title: "يناسب جميع الأقمشة",
  feat4Desc:
    "مصمم خصيصاً للمحافظة على الأقمشة وإزالة التجاعيد بكل سهولة وسلامة، من الحرير إلى الجينز.",
  feat5Title: "عامود قابل للتعديل",
  feat5Desc:
    "علاقة ملابس مع عامود قابل للتطويل والتقصير لسهولة الاستخدام والتنقل.",

  // ===== الأمان =====
  safetyEyebrow: "زاوية الأمان",
  safetyTitle: "مصمم ليكون آمن في بيت فيه أطفال",
  safetySubtitle: "أهم سؤال قبل أي جهاز حراري في البيت: هل هو آمن؟ هذا جوابنا.",
  safetyItems: [
    {
      icon: "fa-power-off",
      title: "إطفاء تلقائي",
      desc: "ينطفئ لحاله عند السخونة الزائدة أو فراغ الخزان.",
    },
    {
      icon: "fa-shield-heart",
      title: "صفر تلامس مباشر",
      desc: "البخار يفرد القماش بدون سطح ساخن يلامسه — لا حرق ولا لمعة.",
    },
    {
      icon: "fa-hand",
      title: "مقبض عازل للحرارة",
      desc: "يظل بارد أثناء التشغيل، وخرطوم معزول بالكامل.",
    },
    {
      icon: "fa-arrows-down-to-line",
      title: "قاعدة مانعة للانزلاق",
      desc: "ثقل موزون في الأسفل يمنع وقوع الجهاز.",
    },
    {
      icon: "fa-lock",
      title: "صمام أمان للخزان",
      desc: "غطاء محكم يمنع تسرّب الماء الساخن أثناء الاستخدام.",
    },
    {
      icon: "fa-plug-circle-check",
      title: "حماية كهربائية",
      desc: "سلك مقاوم للحرارة وقاطع حماية ضد ارتفاع التيار.",
    },
  ],

  // ===== الاستخدامات =====
  solutionsEyebrow: "مش بس قمصان",
  solutionsTitle: "يكوي كل شي في بيتك",
  sol1: "القمصان الرسمية",
  sol2: "الفساتين الحساسة",
  sol3: "الستائر والمفروشات",

  // ===== الآراء =====
  reviewsEyebrow: "محادثات حقيقية مع زبائنا",
  feedbackTitle: "شو قالوا بعد ما",
  feedbackTitleHighlight: "جربوه",

  // يُستخدم في ملخّص صفحة الطلب
  offerPerUnit: "للقطعة",

  // ===== نموذج الطلب =====
  orderBack: "رجوع للمنتج",
  orderEyebrow: "خطوة واحدة وخلصنا",
  orderTitle: "أكمل طلبك",
  orderSubtitle:
    "عبّي المعلومات وبنتواصل معك خلال ساعة لتأكيد الطلب. الدفع عند الاستلام.",
  orderName: "الاسم الكامل",
  orderNamePlaceholder: "مثال: أحمد سليم",
  orderPhone: "رقم الجوال",
  orderPhonePlaceholder: "05X XXX XXXX",
  orderZone: "منطقة التوصيل",
  orderAddress: "العنوان بالتفصيل",
  orderAddressPlaceholder: "المدينة، الحي، الشارع، أقرب معلم",
  orderQty: "الكمية",
  orderSummary: "ملخص الطلب",
  orderProduct: "مكوى بخار عامودي MATRXS",
  orderSubtotal: "المجموع",
  orderShipping: "التوصيل",
  orderFree: "مجاني",
  orderTotal: "الإجمالي المستحق عند الاستلام",
  orderTotalShort: "الإجمالي",
  orderSubmit: "تأكيد الطلب — ادفع عند الاستلام",
  orderSubmitShort: "تأكيد الطلب",
  orderMicro:
    "بياناتك محفوظة وما بتنشارك مع أي جهة. ما بنطلب منك تدفع أونلاين.",
  orderErrName: "اكتب اسمك من فضلك",
  orderErrPhone: "رقم جوال غير صحيح — تأكد منه",
  orderErrAddress: "العنوان قصير — أضف تفاصيل أكثر",
  orderSuccessTitle: "وصلنا طلبك ✅",
  orderSuccessDesc:
    "فتحنا لك محادثة واتساب بتفاصيل الطلب. أرسلها لنا وبنأكدلك خلال ساعة.",
  orderSuccessWhats: "إرسال الطلب عبر واتساب",
  orderSuccessAgain: "تعديل الطلب",
  orderOrCall: "أو اتصل مباشرة",

  // ===== الأسئلة =====
  faqEyebrow: "كل الأسئلة قبل ما تطلب",
  faqTitle: "أسئلة بيسألها كل زبون",
  faqItems: [
    {
      q: "كيف بدفع؟ لازم أدفع أونلاين؟",
      a: "لأ إطلاقاً. الدفع كله عند الاستلام (كاش للمندوب). ما بنطلب منك ولا معلومة بنكية، وما بتدفع ولا شيكل قبل ما تشوف الجهاز وتفحصه.",
    },
    {
      q: "كم بيوصل الطلب؟ وكم رسوم التوصيل؟",
      a: "التوصيل خلال 2-4 أيام للضفة والقدس ومناطق 48، ومجاني بالضفة وسعر رمزي في باقي الباقات. بنتواصل معك تلفونياً قبل التوصيل لنتفق على الوقت المناسب.",
    },

    {
      q: "هل بيحرق القماش الحساس؟",
      a: "لأ. الفكرة كلها إنه ما في سطح ساخن بيلامس القماش — البخار لحاله هو اللي بيرخي ألياف القماش. عشان هيك آمن على الحرير والشيفون والصوف والبدل، مش بس القطن.",
    },
    {
      q: "بينفع للستائر والمفروشات؟",
      a: "نعم، وهاي من أكثر الاستخدامات اللي بيحبها زباينا. بتكوي الستارة وهي معلقة بمكانها بدون ما تفكها، وكذلك الكنب والمفارش.",
    },
    {
      q: "شو نوع المي اللي بستخدمها؟",
      a: "مي الصنبور العادية بتمشي الحال. بس إذا المي عندك قاسية (كلسية)، بننصحك بالمي المفلترة أو المقطّرة عشان يطول عمر الجهاز ويظل البخار قوي.",
    },
    {
      q: "شو بيشمل الوكالة بالضبط؟",
      a: "سنة وكالة على أي عطل تصنيعي — تصليح أو استبدال مجاناً. الوكالة ما بتغطي سوء الاستخدام أو الكسر الناتج عن الوقوع.",
    },
    {
      q: "ليش سعره أغلى من مكواة عادية؟",
      a: "لأنه بديل عن ثلاث أشياء: المكواة، طاولة الكي، وزيارات الدراي كلين. أغلب زباينا بيحسبوا إنه رجّع سعره خلال شهر إلى شهرين من اللي كانوا يدفعوه على كي البدل والستائر بره.",
    },
  ],

  // ===== الفوتر =====
  footerDesc:
    "zalyas هو متجر إلكتروني يهدف إلى تقديم منتجات عالية الجودة بتصميم عصري وتجربة تسوق سهلة وآمنة تلبي احتياجاتك اليومية بلمسة من الفخامة.",
  footerContact: "تواصل معنا",
  footerCall: "اتصل بنا",
  footerLinksTitle: "روابط سريعة",
  copyright: "جميع الحقوق محفوظة.",

  // ===== الشريط الثابت =====
  stickyPrice: "سعر اليوم",
  stickyCta: "اطلب الآن",
};
